import { Button, Group, Modal, Stack, Text } from '@mantine/core'

interface EmailPreviewData {
  recipientEmails: string[]
  body: string
  subject: string
  sourceEmail: string
}

interface EmailPreviewProps {
  opened: boolean
  onClose: () => void
  emailData: EmailPreviewData | null
}

export function EmailPreview({ opened, onClose, emailData }: EmailPreviewProps) {
  if (!emailData) {
    return null
  }

  return (
    <Modal opened={opened} onClose={onClose} title="Email Preview" size="xl">
      <Stack gap="md">
        <Group gap="xs">
          <Text size="sm" fw={500}>
            To:
          </Text>
          <Text size="sm" c="dimmed">
            {emailData.recipientEmails.join(', ')}
          </Text>
        </Group>

        <Group gap="xs">
          <Text size="sm" fw={500}>
            From:
          </Text>
          <Text size="sm" c="dimmed">
            {decodeURIComponent(emailData.sourceEmail)}
          </Text>
        </Group>

        <Group gap="xs">
          <Text size="sm" fw={500}>
            Subject:
          </Text>
          <Text size="sm">{emailData.subject}</Text>
        </Group>

        <div>
          <div
            style={{
              backgroundColor: 'var(--mantine-color-gray-0)',
              padding: '4px',
              borderRadius: '8px',
              border: '1px solid var(--mantine-color-gray-3)',
              maxHeight: '400px',
              overflow: 'auto',
              width: '100%',
            }}
            dangerouslySetInnerHTML={{ __html: emailData.body }}
          />
        </div>

        <Group justify="flex-end" mt="md">
          <Button variant="light" onClick={onClose}>
            Close
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
